import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-shop-drawer',
  templateUrl: './shop-drawer.component.html',
  styleUrls: ['./shop-drawer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ShopDrawerComponent {

}
